<template>
    <div class="action-noti">
        <div
            class="title"
            v-html="msg"
        />
        <div class="body" v-if="body">
            <div v-html="body" />
        </div>
    </div>
</template>
<script>
export default {
    name: 'ActionNoti',
    props: ['message'],
    computed: {
        mustParse() {
            return this.$mustParse(this.message.content) || {}
        },
        body() {
            return this.mustParse.body
        },
        msg() {
            return this.mustParse.msg
        }
    },
}
</script>
